var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 2c.878 0 1.723.34 2.35.948.627.61.983 1.441.983 2.312V6h.296c1.035 0 1.704.943 1.704 1.879v4.242c0 .936-.67 1.879-1.704 1.879H4.37c-1.034 0-1.704-.943-1.704-1.879V7.88C2.666 6.943 3.336 6 4.37 6h.296v-.74c0-.87.356-1.702.983-2.312A3.37 3.37 0 0 1 8 2m-.001 5.667a1.334 1.334 0 0 0-.593 2.525q-.006.038-.007.075v1.466a.6.6 0 0 0 1.2 0v-1.466q-.001-.038-.007-.074a1.333 1.333 0 0 0-.593-2.526M8 3.334a2.04 2.04 0 0 0-1.42.57C6.205 4.267 6 4.755 6 5.26V6h4v-.74c0-.505-.206-.993-.58-1.356A2.04 2.04 0 0 0 8 3.334"
  })));
};
export default SvgLock;